import { ILocation } from '@models/interfaces/ILocation';
import { DefaultLocationFormatter } from '../default-location-formatter';

export class SisLocationFormatter extends DefaultLocationFormatter {
  format(location: ILocation): string[] {
    const line1: string = location.Area2Name;
    const street: string = [location.PlaceName, location.StreetNumber].filter(s => s).join(' ');
    const line2: string = [location.CityName, street, location.AliasName].filter(s => s).join(', ');

    return [line1, line2].filter(s => s);
  }
}
